<section
  [ngClass]="{ 'small-device': isSmallDevice, 'menu-collapsed': !isMenuVisible && !isSmallDevice }"
  [class.version-national]="!isInternational"
  [class.version-international]="isInternational"
  [class.support-hidden]="hideSupportButton"
  data-testid="sms-section"
>
  <app-menu></app-menu>
  <main>
    <app-header></app-header>
    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div>
  </main>
  <a
    *ngIf="!hideSupportButton"
    href="{{ supportLink }}?text=Olá, meu nome é {{
      supportName
    }} e estou com uma dúvida!"
    target="_blank"
    data-testid="whatsapp"
  >
    <img
      class="whatsapp"
      src="/assets/whatsapp.png"
      ngbTooltip="Fale conosco"
      data-testid="whatsapp-image"
    />
  </a>
</section>
